import { useEffect, useState } from 'react'
import {
  getCountries,
  getCountryCallingCode
} from 'react-phone-number-input/input'
import pt from 'react-phone-number-input/locale/pt'
import Input from 'react-phone-number-input/input'
import { parsePhoneNumberFromString } from 'libphonenumber-js' // Garantir esse import
import { Select, MenuItem, Typography, useTheme } from '@material-ui/core'
import { useStyles } from './style'
import { ChevronDown } from 'lucide-react'

export const SelectCountry = ({ value, label, onChange, disabled }) => {
  const classes = useStyles()
  const theme = useTheme()

  const [country, setCountry] = useState('BR')

  // 1. BLINDAGEM DO VALOR: Garante que o input sempre receba o formato internacional
  let normalizedValue = value || ''
  if (normalizedValue && !normalizedValue.startsWith('+')) {
    normalizedValue = `+${normalizedValue}`
  }

  // 2. SINCRONIZAÇÃO DA BANDEIRA: Se o valor recebido de fora (BD) for de outro país,
  // mudamos a bandeira automaticamente para evitar o crash de incompatibilidade.
  useEffect(() => {
    if (normalizedValue) {
      const parsed = parsePhoneNumberFromString(normalizedValue)
      if (parsed && parsed.country && parsed.country !== country) {
        setCountry(parsed.country)
      }
    }
  }, [normalizedValue])

  // const handlePhoneChange = fullPhoneValue => {
  //   // 1. Tratamento para quando o usuário apaga tudo
  //   if (!fullPhoneValue) {
  //     const currentDialCode = getCountryCallingCode(country)
  //     onChange({ countryCode: currentDialCode, telefone: '' })
  //     return
  //   }

  //   // 2. Tenta fazer o parse inteligente do número
  //   const parsed = parsePhoneNumberFromString(fullPhoneValue)
    
  //   if (parsed) {
  //     onChange({
  //       countryCode: parsed.countryCallingCode,
  //       telefone: parsed.nationalNumber
  //     })
  //   } else {
  //     // 3. Fallback seguro para quando o número está incompleto (sendo digitado)
  //     const dialCode = getCountryCallingCode(country)
  //     const national = fullPhoneValue.replace(`+${dialCode}`, '')
      
  //     onChange({
  //       countryCode: dialCode,
  //       telefone: national
  //     })
  //   }
  // }

  const handlePhoneChange = fullPhoneValue => {
    // 1. Tratamento para quando o usuário apaga tudo
    if (!fullPhoneValue) {
      onChange('')
      return
    }

    // 2. Remove o "+" e emite apenas a string numérica limpa para o Formik/Banco
    const cleanNumeric = fullPhoneValue.replace(/\+/g, '')
    onChange(cleanNumeric)
  }

  // const handleCountryChange = e => {
  //   const newCountry = e.target.value
  //   setCountry(newCountry)

  //   // 4. TROCA MANUAL: Se o usuário abrir o dropdown e escolher outro país,
  //   // atualizamos o prefixo do número no input para o novo país.
  //   const dialCode = getCountryCallingCode(newCountry)
  //   onChange(`+${dialCode}`)
  // }

  const handleCountryChange = e => {
    const newCountry = e.target.value
    setCountry(newCountry)

    // 3. TROCA MANUAL: Atualiza o prefixo emitindo apenas a string limpa
    const dialCode = getCountryCallingCode(newCountry)
    onChange(`${dialCode}`)
  }

  return (
    <div className={classes.root}>
      {label && <label className={classes.inputLabel}>{label}</label>}

      <div
        className={`${classes.inputContainer} ${disabled ? classes.disabled : ''}`}
      >
        <Select
          disableUnderline
          value={country}
          onChange={handleCountryChange} // Usando a nova função
          IconComponent={ChevronDown}
          classes={{ select: classes.select, icon: classes.iconChevronDown }}
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left'
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left'
            },
            getContentAnchorEl: null,
            PaperProps: {
              style: {
                maxHeight: 250,
                marginTop: 1,
                maxWidth: 380,
                color:
                  theme.palette.type === 'dark'
                    ? theme.palette.dark_50.main
                    : theme.palette.gray_400.main
              }
            }
          }}
          renderValue={selectedCountry => (
            <div className={classes.flagContainer}>
              <img
                src={`https://flagcdn.com/24x18/${selectedCountry.toLowerCase()}.png`}
                width="20"
                height="14"
                alt="Bandeira"
              />
            </div>
          )}
        >
          {getCountries().map(c => {
            const fullName = pt[c] || c
            const shortName = fullName.split(',')[0].trim()

            return (
              <MenuItem key={c} value={c}>
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                >
                  <img
                    src={`https://flagcdn.com/24x18/${c.toLowerCase()}.png`}
                    width="20"
                    height="14"
                    alt={`Bandeira ${shortName}`}
                    style={{ borderRadius: '2px' }}
                  />
                  <Typography variant="body2">
                    {shortName} (+{getCountryCallingCode(c)})
                  </Typography>
                </div>
              </MenuItem>
            )
          })}
        </Select>

        <div className={classes.divider} />

        <Input
          className={classes.inputPhone}
          country={country}
          value={normalizedValue}
          onChange={handlePhoneChange} // Usando a nova função simplificada
          placeholder="(00) 00000-0000"
          disabled={disabled}
          style={{ border: 'none', outline: 'none', background: 'transparent' }}
        />
      </div>
    </div>
  )
}